import { PlayyardBats } from "./PlayyardBats";
import { PlayyardCauldronPond } from "./PlayyardCauldronPond";
import { PlayyardDriftingGhost } from "./PlayyardDriftingGhost";
import { PlayyardHauntedFence } from "./PlayyardHauntedFence";
import { PlayyardHauntedHouse } from "./PlayyardHauntedHouse";
import { PlayyardPumpkinPatch } from "./PlayyardPumpkinPatch";
import { PlayyardScarecrow } from "./PlayyardScarecrow";

import { playyardHalloween } from "@/lib/playyardHalloween";
import { PlayyardSky } from "@/types";

// Everything seasonal in the yard (IS_PLAYYARD_HALLOWEEN). Rendered as a
// fragment so each piece can slot into the scene's z-order: decor on the
// lawn under the pets, glows and the ghost above the night tint.
export const PlayyardHalloweenLayer = ({ sky }: { sky: PlayyardSky }) => {
  const isSpookyHour = playyardHalloween.isSpookyHour(sky.phase);

  return (
    <>
      <PlayyardHauntedHouse eveningProgress={sky.eveningProgress} />
      <PlayyardHauntedFence hasCrows={!isSpookyHour} />
      <PlayyardScarecrow />
      <PlayyardPumpkinPatch sky={sky} />
      <PlayyardCauldronPond isBrewing={isSpookyHour} />
      {isSpookyHour ? (
        <>
          <PlayyardBats />
          <PlayyardDriftingGhost />
        </>
      ) : null}
    </>
  );
};
